import axiosInstance from "../../../helpers/api";
export const studentsPerGroup = (id) => {
  return axiosInstance.get(`/admin/Reports/group/${id}`);
};

export const videoReport = (id) => {
  return axiosInstance.get(`/admin/Reports/video/${id}`);
};

export const videoFilterReport = (filterData) => {
  return axiosInstance.get(
    `/admin/videos/get_student_viewed_videos/${filterData}`
  );
};
export const attendanceReport = (data) => {
  return axiosInstance.get(
    `/admin/Reports/attend/${data?.lecId}/${data?.date}`
  );
};

export const examReport = (id) => {
  return axiosInstance.get(`/admin/Reports/exam/${id}`);
};

export const unpaidReport = (id, paymentSubjectId = null) => {
  const params = new URLSearchParams();
  if (paymentSubjectId) {
    params.append('payment_subject_id', paymentSubjectId);
  }
  const queryString = params.toString();
  const url = queryString ? `/admin/Reports/students/not_paid/${id}?${queryString}` : `/admin/Reports/students/not_paid/${id}`;
  return axiosInstance.get(url);
};
export const paidReport = (id, lectureId = null) => {
  const params = new URLSearchParams();
  if (lectureId) {
    params.append('lecture_id', lectureId);
  }
  const queryString = params.toString();
  const url = queryString ? `/admin/Reports/paid_students/${id}?${queryString}` : `/admin/Reports/paid_students/${id}`;
  return axiosInstance.get(url);
};
export const examAttendace = (examId, groupId) => {
  const params = new URLSearchParams();
  if (groupId && groupId !== "all") {
    params.append('group_id', groupId);
  }
  const queryString = params.toString();
  const url = queryString ? `/admin/Reports/examAttend/${examId}?${queryString}` : `/admin/Reports/examAttend/${examId}`;
  return axiosInstance.get(url);
};

export const homeworkAttendace = (query) => {
  return axiosInstance.get(`/admin/Reports/homework?${query}`);
};

export const homeworkUncomment = (id) => {
  return axiosInstance.get(
    `/admin/student_homeworks/list_uncommented_hw/${id}`
  );
};
export const filterhomeworkAttendace = ({ homeworkId, groupId }) => {
  return axiosInstance.get(
    `/admin/Reports/homework/${homeworkId}/group/${groupId}`
  );
};

export const homeworkAbsent = (homeworkId, groupId) => {
  const params = new URLSearchParams();
  if (groupId && groupId !== "all") {
    params.append('group_id', groupId);
  }
  const queryString = params.toString();
  const url = queryString ? `/admin/Reports/homeworkAttend/${homeworkId}?${queryString}` : `/admin/Reports/homeworkAttend/${homeworkId}`;
  return axiosInstance.get(url);
};

export const deleteStudentHomework = (data) => {
  return axiosInstance.post(`/superadmin/student_homeworks/reject`, data);
};

export const restrictStudentHomework = (homework_id) => {
  return axiosInstance.put(`/admin/homeworks/restrict_group/${homework_id}`);
};

export const acceptStudentHomework = (homework_id) => {
  return axiosInstance.put(`/admin/homeworks/acceptAll/${homework_id}`);
};

export const commentStudentHomework = (payload) => {
  return axiosInstance.post(
    `/superadmin/student_homeworks/evaluate`,
    payload?.body
  );
};

export const studentPerformance = (id) => {
  return axiosInstance.get(`/admin/payments/${id}`);
};

export const listUnviewedVideos = (videoId, groupIds) => {
  const params = new URLSearchParams();
  if (groupIds && groupIds.length > 0 && !groupIds.includes("all")) {
    groupIds.forEach(groupId => {
      params.append('group_id[]', groupId);
    });
  }
  const queryString = params.toString();
  const url = queryString ? `/admin/videos/list/unviewed_std/${videoId}?${queryString}` : `/admin/videos/list/unviewed_std/${videoId}`;
  return axiosInstance.get(url);
};